import { useState, useEffect } from 'react';
import cn from 'classnames';

import LdsIcon from '../LdsIcon/index.jsx';

import DynamicMenuItemButton from './DynamicMenuItemButton.jsx';
import SubMenu from './SubMenu.jsx';
import MenuItemText from './MenuItemText.jsx';
import SideNavJumpMenu from './SideNavJumpMenu.jsx';

import { isDeepActive, menuItemHasCurrent, deepCurrent } from './SideNav.helpers.js';

const MenuItemToggle = ({ menuItem, isShowingSubMenu }) => {
  if ('subMenu' in menuItem && !('link' in menuItem)) {
    return (
      <div
        className={cn(
          'side-nav-expand-icon',
          {
            open: isShowingSubMenu,
          }
        )}
      >
        <LdsIcon
          key={isShowingSubMenu ? 'expanded' : 'collapsed'}
          label={isShowingSubMenu ? 'Collapse submenu' : 'Expand submenu'}
          name="CaretDown"
          className="lds-side-nav-menu-item-toggle-icon"
        ></LdsIcon>
      </div>
    );
  }

  return '';
};

export default function MenuItem({
  menuItem,
  parentId,
  menuDepth,
  routerLink,
}) {
  const menuItemType = ('link' in menuItem || 'anchor' in menuItem) ? 'link' : 'button';
  const menuItemTypeClass = menuItemType === 'link' ? 'lds-side-nav-menu-item-link' : 'lds-side-nav-menu-item-text';

  const [isShowingSubMenu, setIsShowingSubMenu] = useState(false);

  useEffect(() => {
    const isOpen = menuItem.active
      || (('subMenu' in menuItem) && isDeepActive(menuItem.subMenu))
      || menuItem.current
      || (('link' in menuItem) && ('subMenu' in menuItem) && deepCurrent(menuItem.subMenu));

    setIsShowingSubMenu(isOpen);
  }, [menuItem]);

  const MenuItemIcon = () => {
    let iconName = menuItemHasCurrent(menuItem) && menuItem.activeIcon ? menuItem.activeIcon : menuItem.icon;
    if (!iconName) return '';

    return (
      <LdsIcon
        name={iconName}
        className="lds-side-nav-menu-item-icon"
        inline
        decorative
      />
    );
  };

  const MobileMenuItemToggle = () => {
    if ('subMenu' in menuItem && !('link' in menuItem)) {
      return (
        <>
        <LdsIcon
          key="collapsed-mobile"
          name="CaretRight"
          className="lds-side-nav-menu-item-toggle-icon-mobile ltr-icon"
          inline
          label="Expand submenu"
        ></LdsIcon>
          <LdsIcon
          key="expand-mobile"
          name="CaretLeft"
          className="lds-side-nav-menu-item-toggle-icon-mobile rtl-icon"
          inline
          label="Expand submenu"
        ></LdsIcon>
      </>
      );
    }

    return '';
  };

  return (
    <li
      className={cn(
        'lds-side-nav-menu-item',
        `${menuItemTypeClass}`,
        {
          'has-sub-menu': ('subMenu' in menuItem) || ('jumpMenu' in menuItem),
          'has-jump-menu': 'jumpMenu' in menuItem,
          active: menuItem.active,
          'has-active': menuItem.subMenu && isDeepActive(menuItem.subMenu),
          current: menuItem.current,
          'has-current': menuItemHasCurrent(menuItem),
        }
      )}
    >
      <DynamicMenuItemButton
        menuItem={menuItem}
        parentId={parentId}
        routerLink={routerLink}
        isShowingSubMenu={isShowingSubMenu}
      >
        <MenuItemIcon />
        <span className="lds-side-nav-menu-item-text">
          <MenuItemText menuItem={menuItem} />
        </span>
        <MenuItemToggle menuItem={menuItem} isShowingSubMenu={isShowingSubMenu} />
        <MobileMenuItemToggle />
      </DynamicMenuItemButton>

      <SubMenu menuItem={menuItem} menuDepth={menuDepth} routerLink={routerLink} />
      {menuItem.jumpMenu && menuItem.current && <SideNavJumpMenu menu={menuItem.jumpMenu} menuDepth={menuDepth + 1} />}
    </li>
  );
}
